const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
const PortfolioImage = require('./portfolio_image')
const FacebookVideo = require('module/profile_view/components/video_facebook')
const NfuszVideo = require('module/profile_view/components/video_nfusz')
const VimeoVideo = require('module/profile_view/components/video_vimeo')
const YoutubeVideo = require('module/profile_view/components/video_youtube')
const { isVideoType } = require('lib/video')

function PortfolioItemContent({ item }) {
    switch (item.type) {
        case 'facebook':
            return <FacebookVideo video={item} />
        case 'nfusz':
            return <NfuszVideo video={item} />
        case 'vimeo':
            return <VimeoVideo video={item} />
        case 'youtube':
            return <YoutubeVideo video={item} />
        default:
            return <PortfolioImage image={item} />
    }
}
PortfolioItemContent.propTypes = {
    item: PropTypes.object.isRequired,
}

function PortfolioItemText({ item }) {
    const title = item.title && item.title.trim()
    const description = item.desc && item.desc.trim()
    if (! title && ! description) return null

    const description_classname = classNames('description', {
        'text center': description.length < 120,
    })
    return (
        <div className="portfolio-item-text">
            {title && <h2>{title}</h2>}
            {description && <p className={description_classname}>{description}</p>}
        </div>
    )
}
PortfolioItemText.propTypes = {
    item: PropTypes.object.isRequired,
}

function PortfolioItem({ item }) {
    const is_video = isVideoType(item.type)
    const className = classNames([
        'portfolio-item',
    ], {
        'portfolio-video-item': is_video,
        'portfolio-image-item': ! is_video,
    })

    return (
        <div className={className}>
            <PortfolioItemContent item={item} />
            <PortfolioItemText item={item} />
        </div>
    )
}
PortfolioItem.propTypes = {
    item: PropTypes.object.isRequired,
}

module.exports = PortfolioItem
